import { useContext, useState } from "react";
import { ToastContainer } from "react-toastify";
import Footer from "../../../../components/footer";
import TableMain from "./table";
import ModalRegisterMain from "../modal-register/modal-register";
import { ContextRegister } from "../context-api";
import ModalMain from "../../../../components/modal";
import HeaderReport from "../../../../components/header/report";
import HeaderListFilter from "../../../../components/header/report-filter";
import { generateReport } from "../../../../util/reportRegister";
import ReportModalContent from "../../../../components/report/ReportModalContent";
import AlertMessage from "../../../../components/alert-message";
import Notification from "../../../../components/toast";
import ListTotalReport from "../../../../components/list/list-total";

const MainRegisterMatrix = ({ FormComponent, FormFilter, FormAux }) => {
	const {
		options,
		setSelectData,
		filterData,
		filterListData,
		firstFetch,
		reloadData,
		// reloadFetchFirstData,
		handleOpenModalFilter,
		callBackSubmitModalFilter,
		fetchAllData,
		listDataTotal,
		showSumButton,
		hasSummed,
		handleSumClick,
	} = useContext(ContextRegister);

	const [reportData, setReportData] = useState([]);
	const [reportTotals, setReportTotals] = useState({});
	const [isLoadingReport, setIsLoadingReport] = useState(false);

	const handleOpenModalNewRegister = () => {
		handleOpenModalRegister();
	};

	const handleOpenModalRegister = () => {
		const event = new CustomEvent(`${options.ident}`);
		window.dispatchEvent(event);
	};

	const handleOpenModalReport = async () => {
		try {
			setIsLoadingReport(true);
			const data = await fetchAllData();
			setReportData(data);

			// Calcula a soma de todas as linhas carregadas em memória no frontend
			const totalsResult = {};
			if (options.listDataTotal) {
				options.listDataTotal.forEach((totalField) => {
					// Se a chave for "soma", o campo físico a ser somado nas linhas é "valor"
					const fieldToSum = totalField.key === "soma" ? "valor" : totalField.key;
					const sumValue = data.reduce((acc, item) => acc + Number(item[fieldToSum] || 0), 0);
					
					const totalObj = {
						label: totalField.label || totalField.key,
						value: sumValue,
						format: totalField.format || "",
					};
					
					totalsResult[totalField.key] = totalObj;

					// Se for a chave "soma", replica para "valor" para alinhar no rodapé da coluna de valor no PDF
					if (totalField.key === "soma") {
						totalsResult["valor"] = totalObj;
					}
				});
			}
			setReportTotals(totalsResult);

			const event = new CustomEvent(`${options.identReport}`);
			window.dispatchEvent(event);
		} catch (error) {
			Notification.showToast({
				message: error.message,
				type: "warning",
			});
		} finally {
			setIsLoadingReport(false);
		}
	};

	return (
		<div className="container-register">
			<header className="mt-page">
				<div className="grid grid-cols-2">
					<div className="col-span-1">
						<HeaderReport title={options.title} subTitle={options.subTitle} />
					</div>
					<div className="col-span-1 flex justify-end">
						<div className="flex flex-col gap-1">
							<HeaderListFilter filterData={filterListData} />
							<ListTotalReport listDataTotal={listDataTotal} />
						</div>
					</div>
				</div>

				<ToastContainer />
				{/* <ListFilter filterData={filterData} /> */}

				<ModalRegisterMain
					reloadData={reloadData}
					FormComponent={FormComponent}
					// reloadFetchFirstData={reloadFetchFirstData}
				/>

				<div className="d-flex flex-wrap justify-content-between align-items-center gap-3">
					<button
						className="min-w-40 btn btn-sm btn-success w-15"
						onClick={(e) => handleOpenModalNewRegister()}
					>
						Cadastro {options.title}
					</button>
					<div className="flex gap-2 flex-wrap ">
						<button
							className="min-w-40 btn btn-sm btn-primary w-25"
							onClick={(e) => handleOpenModalFilter(e)}
						>
							Listar
						</button>
						{showSumButton && !hasSummed && (
							<button
								className="min-w-40 btn btn-sm btn-secondary"
								onClick={handleSumClick}
							>
								Soma
							</button>
						)}
						{options.reportColumns && (
							<button
								className="min-w-40 btn btn-sm btn-danger"
								onClick={handleOpenModalReport}
								disabled={isLoadingReport}
							>
								{isLoadingReport ? "Carregando..." : "Relatório"}
							</button>
						)}
					</div>
				</div>
				{options.notice && (
					<AlertMessage type="info">{options.notice}</AlertMessage>
				)}
			</header>
			<main>
				<TableMain handleOpenModalRegister={handleOpenModalRegister} FormAux={FormAux} />
			</main>
			<footer>
				<Footer />
			</footer>
			<ModalMain ident={options.identFilter}>
				<FormFilter
					options={options}
					handleSubmitModalFilter={callBackSubmitModalFilter}
					reloadFilter={filterData}
				/>
			</ModalMain>
			<ModalMain ident={options.identReport}>
				<ReportModalContent
					reportColumns={options.reportColumns}
					data={reportData}
					filters={filterListData}
					title={options.title}
					headerSubtitle={options.subTitle}
					defaultFormat="pdf" // ou "csv"
					totals={reportTotals}
				/>
			</ModalMain>
		</div>
	);
};

export default MainRegisterMatrix;

// const handleGenerateReport = (format = "pdf") => {
// 	const columns = options.reportColumns ?? [];
// 	if (!columns.length) return;

// 	const data = searchedData ?? [];
// 	if (!data.length) return;

// 	generateReport({
// 		data,
// 		filters: filterListData,
// 		columns,
// 		format, // "pdf" ou "xlsx"
// 		fileName: `Relatório ${options.title}`,
// 	});
// };
